import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { getErrorString, getUserDetail, isOwner, isOwnerId } from '../../constants/function';
import { addSongsAction } from '../../action/songs';
import ApiService from './../../services/api-service';
import notifier from './../../components/Notifier';
import './SkDrawerStudio.scss';
import { Box, Stack, Typography } from '@mui/material';
import Chips from '../Chips';
import AddIcon from '@mui/icons-material/Add';
import MusicCard from '../MusicCard';
import NoData from '../Nodata';
import AddPopup from '../AddPopup';
import ConfirmPopup from '../ConfirmPopup';
import Loader from '../Loader';
import emitter from '../../EventEmitter';
import { act } from '../../constants/common';

export default function SkDrawerStudio(props) {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();
    const [loaded, setLoaded] = useState(false);
    const [active, setActive] = useState(0);
    const history = useHistory();
    const { _id } = useParams();
    const [setOpen] = React.useState(false);
    const [playlist, setPlaylist] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addPlaylist, setaddPlaylist] = React.useState(false);
    const [editPlaylist, seteditPlaylist] = React.useState(false);
    const [pageNo, setPageNo] = useState(1);
    const userDetail = getUserDetail();
    const [selectedId, setSelectedAlbum] = React.useState();
    const [selectedIndex, setSelectedIndex] = React.useState(null);
    const [openConfirm, setOpenConfirm] = React.useState(false);

    const toggleDrawer = (value, id, index) => {
        setSelectedIndex(index);
        setSelectedAlbum(id);
        if (value && id) {
            makeAction(value, id, index);
        }
    };

    const makeAction = async (key, id, index) => {
        switch (key) {
            case 'Remove Studio':
                setOpenConfirm(true);
                break;
            case 'm26':
                if (
                    active > 0 &&
                    !isOwnerId(playlist[index]['createdBy']) &&
                    !playlist[index]['isSubscribed'] &&
                    playlist[index]['private']
                ) {
                    notifier.error(t('notifier.error.toast5'));
                } else if (typeof playlist[index].music === 'number') {
                    const tempMusic = await getPlayListMusic(id);
                    if (tempMusic.length)
                        dispatch(
                            addSongsAction(tempMusic, false, playlist[index]['_id'], 0),
                        );
                } else
                    dispatch(
                        addSongsAction(
                            playlist[index].music,
                            false,
                            playlist[index]['_id'],
                            0,
                        ),
                    );

                break;
            case 'm27':
                emitter.emit( act.CLOSE_DRAWER )
                history.push(
                    `/app/PlaylistStatics/${id}/${playlist[index]['createdBy']}`,
                );
                break;
            case 'm30':
                setSelectedAlbum(id);
                seteditPlaylist(true);
                break;
            case 'Sell NFT':
                emitter.emit( act.CLOSE_DRAWER )
                history.push(`/app/SellAuctionPlayList/${playlist[index]['nftId']}`);
                break;
            case 'm6':
                markPrivate(id, index);
                break;
            case 'm5':
                markPrivate(id, index);
                break;
            default:
                break;
        }
    };

    const getPlayListMusic = async (_id) => {
        try {
            setLoading(true);
            const response = await ApiService.PLAYLIST_DETAIL({
                _id: _id,
                pageNo: 1,
                pageSize: 100,
            });

            setLoading(false);

            return response['result']['music'] || [];
        } catch (error) {
            setLoading(false);
            if (getErrorString(error) !== 'Artist has no music')
                notifier.error(getErrorString(error));
            return [];
        }
    };

    const deletePlaylist = async (id, index) => {
        try {
            setOpenConfirm(false);
            setLoading(true);
            const response = await ApiService.DELETE_PLAYLIST(id);
            const tempPlaylist = playlist;
            tempPlaylist.splice(index, 1);
            setPlaylist([...tempPlaylist]);

            setLoading(false);
        } catch (error) {
            notifier.error(getErrorString(error));
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userDetail) {
            let tab = 0;
            switch (_id) {
                case 'Me':
                    setActive(0);
                    tab = 0;
                    getPlaylist(userDetail['_id'], tab, pageNo);
                    break;
                case 'BuyMe':
                    setActive(1);
                    tab = 1;
                    getPlaylist(userDetail['_id'], tab, pageNo);
                    break;
                case 'Saved':
                    setActive(2);
                    tab = 2;
                    getPlaylist(userDetail['_id'], tab, pageNo);
                    break;
                case 'MostListen':
                    setActive(3);
                    tab = 3;
                    getPlaylist(userDetail['_id'], tab, pageNo);
                    break;
                case 'MostTipped':
                    setActive(4);
                    tab = 4;
                    getPlaylist(userDetail['_id'], tab, pageNo);
                    break;
                default:
                    setActive(0);
                    getPlaylist(userDetail['_id'], tab, 1);
                    break;
            }
        }
    }, [_id]);

    const getPlaylist = async (_id, tab, pageNo) => {
        try {
            setLoading(true);
            const response =
                tab === 0
                    ? await ApiService.TOPTEN_MY_PLAYLIST({
                        pageNo: pageNo,
                        pageSize: 10,
                    })
                    : tab === 1
                        ? await ApiService.TOPTEN_BUY_ME_PLAYLIST({
                            pageNo: pageNo,
                            pageSize: 10,
                        })
                        : tab === 2
                            ? await ApiService.TOPTEN_SAVED_PLAYLIST()
                            : tab === 3
                                ? await ApiService.TOPTEN_LISTEN_PLAYLIST()
                                : await ApiService.TOPTEN_TIP_PLAYLIST();
            setLoading(false);
            if (tab === 0 && pageNo === 1) {
                setLoaded(response['result'].length < 10 ? true : false);
                setPlaylist([...response['result']]);
            } else if (tab === 0 && pageNo > 1) {
                setLoaded(response['result'].length < 10 ? true : false);
                setPlaylist([...playlist, ...response['result']]);
            } else setPlaylist([...response['result']]);
        } catch (error) {
            setLoading(false);
            setPlaylist([]);
            notifier.error(getErrorString(error));
        }
    };

    const handleScroll = async (target) => {
        var a = target.scrollTop;
        var b = target.scrollHeight - target.clientHeight;

        if ((a / b) * 100 > 80 && !loading && !loaded && active === 0) {
            // run a function called doSomething
            const next = pageNo + 1;
            setPageNo(next);
            getPlaylist(_id ? _id : userDetail['_id'], active, next);
        }
    };

    const handleClosePopup = (e, close, url, explicit) => {
        setaddPlaylist(close);
        seteditPlaylist(close);
        if (e && typeof e === 'object' && !close && !url) {
            const tempPlaylist = playlist;
            tempPlaylist.unshift(e);
            setPlaylist([...tempPlaylist]);
        } else if (url || typeof explicit === 'boolean') {
            const tempPlaylist = playlist;
            if (url) tempPlaylist[e]['GIF'] = url;
            if (typeof explicit === 'boolean')
                tempPlaylist[e]['isExplicit'] = explicit;
            setPlaylist([...tempPlaylist]);
        } else {
            setaddPlaylist(false);
            seteditPlaylist(false);
        }
    };

    const markPrivate = async (id, index) => {
        try {
            setLoading(true);
            const response = await ApiService.ASSET_PRIVACY({
                assetId: id,
                type: 'playlist',
                private: !playlist[index].private,
            });
            //making nft public private
            const response1 = await ApiService.ASSET_PRIVACY({
                assetId: playlist[index]?.nftDetails?._id,
                type: 'playlistNFT',
                private: !playlist[index].private,
            });
            const temp = playlist;
            temp[index].private = !temp[index].private;
            setPlaylist([...temp]);
            notifier.success(response['result']);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    };

    const handleTabSwitch = (tab) => {
        setActive(tab);
        setPlaylist([]);
        setPageNo(1);

        switch (tab) {
            case 0:
                history.push(`/app/Playlists/Me`);
                break;
            case 1:
                history.push(`/app/Playlists/BuyMe`);
                break;
            case 2:
                history.push(`/app/Playlists/Saved`);
                break;
            case 3:
                history.push(`/app/Playlists/MostListen`);
                break;
            case 4:
                history.push(`/app/Playlists/MostTipped`);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        return () => {
            setPlaylist([]);
            setPageNo(0);
        };
    }, []);

    useEffect(() => {
    }, [selectedId]);

    return (
        <Box className="__playlists__">
            <p className="text-center text-xl font-bold pt-2 pb-2"> Studios </p>
            <Box
                className="__main_padding"
                onScroll={(e) => handleScroll(e.target)}
                sx={{ height: '100vh', overflow: 'scroll' }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    overflow="auto"
                    padding="15px 0 0 0"
                    style={{
                        position: 'sticky',
                        top: '0',
                        zIndex: '1',
                        backgroundColor: '#090909',
                    }}
                >
                    {[
                        t('studio.tabs.tab1'),
                        t('studio.tabs.tab5'),
                        t('studio.tabs.tab2'),
                        t('studio.tabs.tab3'),
                        t('studio.tabs.tab4'),
                    ].map((label, index) => (
                        <Chips
                            key={index}
                            label={label}
                            index={index}
                            activeTab={active}
                            handleClick={(tab) => handleTabSwitch(tab)}
                        />
                    ))}
                </Stack>

                <Box
                    sx={{
                        position: 'relative',
                        flexWrap: 'wrap',
                        minHeight: '100px',
                    }}
                    className="__playlists_card flex-responsive"
                >

                    {playlist.length > 0 &&
                        playlist.map((p, index) => (
                            <MusicCard
                                tip={p?.tip}
                                tab={active}
                                listens={p?.listens}
                                platform={p?.nftDetails?.platform || p?.platform}
                                isPlaylist={true}
                                isPlaylistNft={
                                    (p['nftId'] || p?.nftDetails) && active < 2 ? true : false
                                }
                                music={p}
                                nftId={p?.nftDetails._id}
                                key={p['GIF'] ? p['GIF']['filePath'] : p['_id']}
                                actions={
                                    isOwner(
                                        p['owner'] && typeof p['owner'] === 'object'
                                            ? p['owner']['email']
                                            : p['createdByDetails']
                                                ? p['createdByDetails']['email']
                                                : p['uploader']
                                                    ? p['uploader']['email']
                                                    : '',
                                    )
                                        ? [
                                            p?.music > 0
                                                ? { key: 'm26', action: t('dropMenu.m26') }
                                                : '',
                                            // "Remove Studio",
                                            { key: 'm30', action: t('dropMenu.m30') },
                                            { key: 'm27', action: t('dropMenu.m27') },
                                            p['private']
                                                ? { key: 'm5', action: t('dropMenu.m5') }
                                                : { key: 'm6', action: t('dropMenu.m6') }
                                            // p["nftId"] ? "Sell NFT" : "",
                                        ]
                                        : [
                                            { key: 'm26', action: t('dropMenu.m26') },
                                            { key: 'm27', action: t('dropMenu.m27') },
                                            p['private']
                                                ? { key: 'm5', action: t('dropMenu.m5') }
                                                : { key: 'm6', action: t('dropMenu.m6') }
                                        ]
                                }
                                toggleMenu={(action) => toggleDrawer(action, p['_id'], index)}
                                cardIndex={index}
                            />
                        ))}
                    {(!_id || _id === 'Me') && active === 0 ? (
                        <Box>
                            <Box
                                className="__card__add _cp"
                                sx={{
                                    border: '2px dashed #999999',
                                    borderRadius: '6px',

                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                onClick={() => setaddPlaylist(true)}
                            >
                                <AddIcon style={{ color: '#999999', fontSize: '50px' }} />
                            </Box>
                            <Typography className="fs-14">{t('studio.add')}</Typography>
                        </Box>
                    ) : null}
                    {playlist.length === 0 && active !== 0 ? (
                        <NoData lable={t('noData.noData')} />
                    ) : null}
                </Box>
            </Box>

            {addPlaylist ? (
                <AddPopup
                    api="playlist"
                    title={t('addPopup.title1')}
                    open={addPlaylist}
                    handleClose={(e, close) => handleClosePopup(e, close)}
                />
            ) : null}

            {editPlaylist ? (
                <AddPopup
                    selectedIndex={selectedIndex}
                    id={selectedId}
                    api="playlist"
                    image={
                        playlist[selectedIndex]['GIF']
                            ? playlist[selectedIndex]['GIF']['filePath']
                            : playlist[selectedIndex]['thumbnailImg']
                                ? playlist[selectedIndex]['thumbnailImg']['filePath']
                                : ''
                    }
                    title={t('addPopup.title2')}
                    isExplicit={playlist[selectedIndex]['isExplicit']}
                    open={editPlaylist}
                    handleClose={(e, close, url, explicit) =>
                        handleClosePopup(e, close, url, explicit)
                    }
                />
            ) : null}

            {openConfirm && playlist.length > 0 ? (
                <ConfirmPopup
                    id={selectedId}
                    index={selectedIndex}
                    message={`${t('confirmPopup.text1')} "${
                        playlist[selectedIndex]['title']
                    }" ${t('confirmPopup.text2')}?`}
                    open={openConfirm}
                    handleClose={(e, id, index) =>
                        e ? deletePlaylist(id, index) : setOpenConfirm(false)
                    }
                />
            ) : null}

            {loading ? <Loader /> : null}

        </Box>
    );
}